import { FC } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useGuardianState, useGuardianActions } from '../contexts/guardian.context';
import { useNavigate } from 'react-router-dom';
import { pages } from '../../../../utils/common';

const ChildSwitcher: FC = () => {
  const { selectedChildId, children } = useGuardianState();
  const { setSelectedChild } = useGuardianActions();
  const navigate = useNavigate();

  if (children.length <= 1) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newChildId = event.target.value;
    setSelectedChild(newChildId);
    navigate(`${pages.guardian.path}${pages.guardian.subPages?.dashboard?.path}`, {
      replace: true,
    });
  };

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: { xs: 150, sm: 200 },
      }}
      data-testid="child-switcher"
    >
      <Select
        value={selectedChildId || ''}
        onChange={handleChange}
        displayEmpty
        sx={{
          fontSize: { xs: '14px', sm: '16px' },
          minHeight: { xs: '44px', sm: '40px' },
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                minHeight: '44px',
                fontSize: { xs: '16px', sm: '14px' },
                padding: { xs: '12px 16px', sm: '8px 16px' },
              },
            },
          },
        }}
      >
        {children.map((child) => (
          <MenuItem key={child.id} value={child.id}>
            {child.name} {child.grade ? `(${child.grade}${child.section ? ` - ${child.section}` : ''})` : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ChildSwitcher;
